export class Dimensions {
    Height: any; 
    Length: any; 
    Width: any;     
} 
    